import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import Grid2 from '@mui/material/Grid2';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { useSettings } from '../hooks/useSettings';
import { useFormOperations } from '../hooks';
import useAlias from '@src/hooks/useAlias';

interface GroupHeaderProps {
  group: {
    uiLabel: string;
    controllerField: string;
  };
  groupIndex: number;
}

const GroupHeader: React.FC<GroupHeaderProps> = ({ group, groupIndex }) => {
  const alias = useAlias();
  const { startEditSetting: handleEditSetting } = useSettings();

  const { showDeleteConfirm } = useFormOperations();
  return (
    <Grid2 size={12} sx={{ mt: groupIndex > 0 ? 2 : 0 }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Typography variant='subtitle1' fontWeight='bold'>
          {group.uiLabel}
        </Typography>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <IconButton
            size='small'
            sx={{ opacity: 0.6 }}
            onClick={() => handleEditSetting({ ...group, fields: [] })}
            title={alias('Edit setting')}
          >
            <EditIcon fontSize='small' />
          </IconButton>
          <IconButton
            size='small'
            sx={{ opacity: 0.6 }}
            onClick={() => showDeleteConfirm('setting', group.controllerField)}
            title={alias('Delete setting')}
          >
            <DeleteOutlineIcon fontSize='small' />
          </IconButton>
        </Box>
      </Box>
    </Grid2>
  );
};

export default GroupHeader;
